
    const target = import.meta.env.VITE_TARGET || 'web';
    if (target === 'desktop') {
      import('/src/entry/desktop.tsx');
    } else {
      import('/src/entry/web.tsx');
    }
  